import React, { useEffect, useState } from "react";
import "./styles.scss";
// import "./mobile.scss";
import {
  Button,
  CheckItem,
  FormCheck,
  FormHeader,
  InputBox,
  SectionHeader,
  TopMenu,
} from "../../components";
import "react-notifications-component/dist/theme.css";
import { CheckValidity } from "../../utils/formValidity";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import StartNewAdCampaign from "../templates/startNewAdCampaign";
import { Flex, Progress } from "antd";
import AdvWebImageUploader from "../templates/advWebImageUploader";
import AdsCampaignTimeSchedular from "../templates/adsCampaignTimeSchedular";
import { GetIconByName } from "../../config/icon";

const AdsCampaign = (props) => {
  const dispatch = useDispatch();
  const [formVizard, setFormVizard] = useState(1);

  const getOverallProgress = (currentStep) => {
    switch (currentStep) {
      case 1:
        return { percent: 30, status: "active" };
      case 2:
        return { percent: 60, status: "active" };
      case 3:
        return { percent: 100, status: "normal" }; // or "success"
      default:
        return { percent: 0, status: "exception" };
    }
  };
  const goToNext = () => {
    if (formVizard < 3) {
      setFormVizard(formVizard + 1);
    } else {
      // Handle form submission or final action
      console.log("Final step reached, submit the form or perform an action.");
    }
  };

  const goBack = () => {
    if (formVizard > 1) {
      setFormVizard(formVizard - 1);
    } else {
      // Handle form submission or final action
      console.log("Final step reached, submit the form or perform an action.");
    }
  };

  return (
    <>
      <div className={"ads-campaign-wrapper "}>
        <div>
          <TopMenu
            data={{
              size: "sm",
              isLanguage: false,
              isLogo: true,
              isProfile: true,
              isAds: true,
            }}
          />
        </div>
        <div className={"acwb__header"}>
          <FormHeader
            data={{
              formHeader: "Start a new ad campaign.",
              size: "md-md",
            }}
          />
          <SectionHeader
            data={{
              title:
                "Reach more customers with a customized ad tailored to your goals.",
              size: "md-sm",
            }}
          />

          {/* <Flex gap="small" vertical>
            <Progress percent={30} showInfo={false} />
            <Progress percent={60} status="active" />
            <Progress percent={70} status="exception" />
            <Progress percent={100} />
          </Flex> */}
          <div className="d-flex justify-content-center align-items-center">
            <Progress
              {...getOverallProgress(formVizard)}
              showInfo={false}
              strokeColor=" #C40B4A"
              trailColor=" #FA1C690A"
            />
          </div>
        </div>

        {formVizard > 1 && (
          <div className="acw__back" onClick={goBack}>
            {GetIconByName("h-wrrow-left")}Back
          </div>
        )}

        <div className={"acw__body container"}>
          {formVizard === 1 && (
            <>
              <StartNewAdCampaign onNext={goToNext} />
            </>
          )}
          {formVizard === 2 && (
            <>
              <AdvWebImageUploader onNext={goToNext} />
            </>
          )}
          {formVizard === 3 && (
            <>
              <AdsCampaignTimeSchedular />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(AdsCampaign);
